import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14.7564 26.1947L0.515134 11.9533C-0.171711 11.2665 -0.171711 10.1529 0.515134 9.46617L2.17615 7.80516C2.86182 7.11948 3.9731 7.11816 4.66039 7.80222L16 19.0887L27.3396 7.80222C28.0269 7.11816 29.1382 7.11948 29.8238 7.80516L31.4849 9.46617C32.1717 10.153 32.1717 11.2666 31.4849 11.9533L17.2437 26.1947C16.5568 26.8815 15.4433 26.8815 14.7564 26.1947Z" })
});
export default SvgIconChevronDown;
